import React from 'react';
import { ButtonProps, CircularProgress, Grid, GridProps } from '@mui/material';
import {
  SparkFormResetButton,
  SparkFormButton,
} from 'sharedComponents/SparkForm';
import { SparkButton } from 'sharedComponents/UI';

type SparkBasicFormFooterProps = {
  isDisabled?: boolean;
  shouldRequireFieldUpdates?: boolean;

  primaryButtonText?: string | undefined;
  primaryButtonStyles?: ButtonProps['sx'];

  resetButtonText?: React.ReactNode | string | undefined;
  resetButtonType?: 'reset' | 'button';
  resetButtonStartAdornment?: React.ReactNode;
  shouldRenderResetButton?: boolean;
  resetButtonStyles?: ButtonProps['sx'];
  onResetButtonClick?: () => void;

  containerProps?: GridProps;
  isLoading?: boolean;

  tooltipMessage?: string;
};

function SparkBasicFormFooter({
  isDisabled = false,
  shouldRequireFieldUpdates = true,

  primaryButtonText = 'Save',
  primaryButtonStyles = {},

  resetButtonText = 'Reset',
  resetButtonType = 'reset',
  shouldRenderResetButton = false,
  resetButtonStartAdornment,
  resetButtonStyles = {},
  onResetButtonClick,

  containerProps = {},
  isLoading = false,

  tooltipMessage = '',
}: SparkBasicFormFooterProps) {
  return (
    <Grid
      item
      container
      xs={12}
      paddingBottom={2}
      gap={2}
      justifyContent={shouldRenderResetButton ? 'flex-end' : 'space-between'}
      flexWrap='nowrap'
      {...containerProps}
    >
      {shouldRenderResetButton && resetButtonType === 'reset' && (
        <SparkFormResetButton
          variant='outlined'
          fullWidth={true}
          disabled={isDisabled || isLoading}
          shouldRequireFieldUpdates={shouldRequireFieldUpdates}
          startIcon={resetButtonStartAdornment}
          sx={{ padding: '10px 20px', marginTop: '10px', ...resetButtonStyles }}
        >
          {resetButtonText}
        </SparkFormResetButton>
      )}
      {shouldRenderResetButton &&
        resetButtonType === 'button' &&
        onResetButtonClick && (
          <SparkButton
            variant='outlined'
            fullWidth={true}
            disabled={isDisabled || isLoading}
            sx={{
              padding: '10px 20px',
              marginTop: '10px',
              ...resetButtonStyles,
            }}
            onClick={onResetButtonClick}
            startIcon={resetButtonStartAdornment}
          >
            {resetButtonText}
          </SparkButton>
        )}
      <SparkFormButton
        fullWidth={true}
        sx={{
          padding: '10px 20px',
          marginTop: '10px',
          ...primaryButtonStyles,
        }}
        disabled={isDisabled || isLoading}
        shouldRequireFieldUpdates={shouldRequireFieldUpdates}
        tooltipMessage={tooltipMessage}
      >
        {isLoading ? (
          <CircularProgress
            size={25}
            thickness={6}
            sx={{ color: (theme) => theme.palette.grey[500] }}
          />
        ) : (
          primaryButtonText
        )}
      </SparkFormButton>
    </Grid>
  );
}

export default SparkBasicFormFooter;
